module.exports = __webpack_public_path__ + "img/jungle-temple.10bc039a.jpg";